import { render, staticRenderFns } from "./AxRowAligned.vue?vue&type=template&id=fda477b0"
import script from "./AxRowAligned.vue?vue&type=script&lang=ts"
export * from "./AxRowAligned.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports